import { defineComponent as n, openBlock as r, createBlock as l, unref as d, mergeProps as p, withCtx as c, createElementVNode as a } from "vue";
import { RevIcon as h } from "@ds/components/Icon";
const s = /* @__PURE__ */ n({
  name: "IconSdhcCard",
  __name: "IconSdhcCard",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (m, e) => (r(), l(d(h), p(t, { "view-box": "0 0 24 24" }), {
      default: c(() => [...e[0] || (e[0] = [
        a("path", { d: "M5 8.25A.75.75 0 0 1 5.75 7.5h6.5a.75.75 0 0 1 0 1.5h-6.5A.75.75 0 0 1 5 8.25m.75 2.25a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5h-3.5" }, null, -1),
        a("path", {
          "fill-rule": "evenodd",
          d: "M4 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h4.586a1 1 0 0 0 .707-.293l.5-.5a.7.7 0 0 1 .5-.207H10.5a.5.5 0 0 1 .5.5.5.5 0 0 0 .5.5h2.197a1 1 0 0 0 .555-.168l2.496-1.664A1 1 0 0 1 17.303 18H20a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4m16 1.5H4A.5.5 0 0 0 3.5 6v12A.5.5 0 0 0 4 18.5h4.379l.353-.354a2.2 2.2 0 0 1 1.56-.646H10.5a2 2 0 0 1 1.732 1h1.314l2.37-1.58a2.5 2.5 0 0 1 1.387-.42H20a.5.5 0 0 0 .5-.5V6A.5.5 0 0 0 20 5.5",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  s as default
};
